<template>
  <div>
    <common-hero title="About us" subTitle="" />
    <!--team-area-start-->
    <div class="team-area">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-title">
              <h3>
                Lorem ipsum dolor sit amet <br />
                conseptetum
              </h3>
              <p>
                Emerging is a HR consultancy specialist in corporate and Higher Education
                institutions <br />
                relations, with a focus on optimizing recruitment and integrating young talents.
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 col-md-6">
            <div class="single-team">
              <div class="team-img">
                <img src="assets/img/team1.png" alt="" />
              </div>
              <div class="team-containt">
                <h3>Caroline Depierre</h3>
                <p>
                  has been for over 10 years a Research Director in the executive board of
                  Trendence, a leading research agency specializing in international employer
                  branding. She is an expert in designing and operating large-scale research
                  projects for major brands. Her focus lies on developing concepts and methods to
                  turn data into actionable insights for employers and universities.
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6">
            <div class="single-team">
              <div class="team-img">
                <img src="assets/img/team2.png" alt="" />
              </div>
              <div class="team-containt">
                <h3>Thomas Vié</h3>
                <p>
                  works in analytics since 1999. First as C.T.O. of several data oriented companies,
                  then C.E.O. of an Email Service provider located in Argentina. His focus is now on
                  the technical side of data expertise, visualization and analysis, using the newest
                  algorithms and tools to extract useful sense from raw material.
                </p>
                <a href="#">Learn more<i class="far fa-long-arrow-alt-right"></i></a>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="blog-area">
              <div class="blog-title">
                <h3>Title section lorem ipsum dolor sit amet</h3>
                <p>
                  Subtitle section this research work is a unique and very powerful source of
                  information providing guidance for professionals in Higher Education, students and
                  companies.
                </p>
                <p class="mo">
                  Standard text In a competitive environment increasingly impacted by the
                  globalization of the higher education market and the digitalization of the global
                  economy, what strategy should universities adopt to meet the demands of the market
                  in a sustainable way? Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
                  veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
                  consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
                  dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                  sunt in culpa qui officia deserunt mollit anim id est laborum.
                </p>
                <p class="mo">
                  Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium
                  doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore
                  veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam
                  voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur
                  magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est,
                  qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non
                  numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat
                  voluptatem.
                </p>
              </div>
              <div class="blog-text">
                <h3>Inter title Pioneers in employability</h3>
                <p>
                  Emerging has been producing the Global Employability Survey and Ranking since 2010
                  and collected the feedback of over <span>80,000 top recruiters</span> in more than
                  <span>22 countries</span> on over <span>6,000 institutions</span> regarding the
                  employability of their graduates. This research work aggregating 10 years of data
                  and <span>1 million university evaluations </span>is a unique and very powerful
                  source of information providing guidance for experts and professionals in Higher
                  Education. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi
                  ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in
                  voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                  <a href="#">Text link cupidatat non proident</a>, sunt in culpa qui officia
                  deserunt mollit anim id est laborum.
                </p>
                <p>
                  Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium
                  doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore
                  veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam
                  voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur
                  magni dolores eos qui ratione voluptatem sequi nesciunt.
                </p>
              </div>
              <div class="blog-text">
                <h3>Inter title Pioneers in employability</h3>
                <p>
                  Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium
                  doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore
                  veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam
                  voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur
                  magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est,
                  qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non
                  numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat
                  voluptatem.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--team-area-end-->
  </div>
</template>
<script>
import CommonHero from '@/components/CommonHero';

export default {
  components: {
    CommonHero
  }
};
</script>

<style lang="scss" scoped></style>
